"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LayoutDashboard, CheckSquare, ClipboardCheck, Users, Mic } from "lucide-react";

const links = [
  { href: "/", label: "Content Pipeline", icon: LayoutDashboard },
  { href: "/tasks", label: "Tasks Board", icon: CheckSquare },
  { href: "/leads", label: "Leads", icon: Users },
  { href: "/podcasts", label: "Podcasts", icon: Mic },
  { href: "/audit/admin", label: "Audit", icon: ClipboardCheck },
];

export function Sidebar() {
  const path = usePathname();
  return (
    <aside className="w-64 shrink-0 border-r border-[var(--border)] bg-[var(--bg-card)] flex flex-col max-md:hidden">
      <div className="p-5 border-b border-[var(--border)]">
        <h1 className="text-lg font-bold flex items-center gap-2">
          🚀 Mission Control
        </h1>
        <p className="text-xs text-[var(--text-muted)] mt-1">Karl & Casey 🐕</p>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {links.map((l) => {
          const active = path === l.href;
          return (
            <Link
              key={l.href}
              href={l.href}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors no-underline ${
                active
                  ? "bg-[var(--accent)] text-white"
                  : "text-[var(--text-muted)] hover:bg-[var(--bg-hover)] hover:text-[var(--text)]"
              }`}
            >
              <l.icon size={18} />
              {l.label}
            </Link>
          );
        })}
      </nav>
      <div className="p-4 border-t border-[var(--border)] text-xs text-[var(--text-muted)]">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-lg">👤</span> Karl — Coach
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lg">🐕</span> Casey — AI Assistant
        </div>
      </div>
    </aside>
  );
}
